import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { MarketingAnalyticsPhoneNumberInput } from '@/models/marketing';

export const updateMarketingAnalyticsPhoneNumber = async ({
  phoneNumber,
  data,
}: {
  phoneNumber: string;
  data: MarketingAnalyticsPhoneNumberInput;
}) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      data,
    },
    mutation: graphql(`
      mutation UpdateMarketingAnalyticsPhoneNumber($phoneNumber: String!, $data: MarketingAnalyticsPhoneNumberInputType!) {
        updateMarketingAnalyticsPhoneNumber(phoneNumber: $phoneNumber, data: $data) {
          phoneNumber
          description
          media
          platform
          existingCampaign
          notExistingCampaign
          regSource
          isActive
        }
      }
    `),
  });

  return response.data?.updateMarketingAnalyticsPhoneNumber;
};
